import React from 'react';
import PropTypes from 'prop-types';
import { withBreakpoint } from 'contest/components/breakpoints';

const DrawerApp = (props) => {
    switch (props.breakpoint) {
        case 'small':
            return <props.fullscreenDrawer buttonLayout="stacked" {...props} />;
        case 'medium':
            return <props.fullscreenDrawer buttonLayout="fluid" {...props} />;
        default:
            return <props.drawer {...props} />;
    }
};

DrawerApp.propTypes = {
    breakpoint: PropTypes.string.isRequired,
    drawer: PropTypes.func.isRequired,
    fullscreenDrawer: PropTypes.func.isRequired,
};

export default withBreakpoint(DrawerApp);



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/drawer-app.jsx